export default {
  CARD_START: 'Start',
  CARD_LOCKED: 'Låst',
  CARD_DONE: 'Repeter',
  CARD_IN_PROGRESS: 'Fortsette',
  CARD_DONE_LINK: 'Sjå oppgåvene',
  CARD_ITEMS_FINISHED: 'stader fullført',
}
